export const WEBSITE_TYPES = ["Business Website", "Landing Page", "Portfolio", "Booking Website", "Blog", "Other"];
export const FEATURES = ["Contact Form", "Quote Request Form", "Booking System", "Customer Accounts", "Blog", "Image Gallery", "Social Media Integration", "Google Maps", "Newsletter Signup", "Custom Features"];
export const BUDGETS = ["Under $500", "$500–$1,000", "$1,000–$2,500", "$2,500–$5,000", "$5,000+", "I'm not sure"];
export const STEP_LABELS = ["About You", "Your Website", "Features", "Budget", "Project Details", "Submit"];

export const EMPTY_FORM = { full_name: "", business_name: "", phone: "", email: "", website_type: "", features: [], budget: "", details: "" };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function validateStep(step, f) {
  const e = {};
  if (step === 0) {
    if (f.full_name.trim().length < 2) e.full_name = "Please enter your full name.";
    if (!f.business_name.trim()) e.business_name = "Please enter your business name.";
    const digits = f.phone.replace(/\D/g, "");
    if (digits.length < 8 || digits.length > 15) e.phone = "Please enter a valid phone number.";
    if (!EMAIL_RE.test(f.email.trim())) e.email = "Please enter a valid email address.";
  }
  if (step === 1 && !f.website_type) e.website_type = "Please choose the type of website you need.";
  if (step === 3 && !f.budget) e.budget = "Please choose an approximate budget range.";
  if (step === 4 && f.details.trim().length < 10) e.details = "Please tell us a little more about your project (at least 10 characters).";
  return e;
}
